import { PurchaseButton } from "./purchase-button.js";

/**
 * Credits CTA — a PurchaseButton preset for the recharge flow.
 *
 * It only fixes *policy*, inheriting all behaviour (URL resolution, token
 * renewal, lovoo's payment-success listener) from PurchaseButton:
 *   • purchase-type is always "credits";
 *   • include-token is derived from the brand — TMG brands exchange the session
 *     for a token and open the recharge URL (economy.purchase.url), while lovoo
 *     is not on the TMG economy backend, so it opens the old POS session (no
 *     token) with is-only-payment. A template may still set `include-token`
 *     explicitly to override this default.
 *   • the icon is hidden on mobile (shown on desktop), matching the header and
 *     mobile-nav placements where the button renders text-only on phones.
 */
export class BuyCreditsButton extends PurchaseButton {
  constructor() {
    super();
    this.purchaseType = "credits";
    this.iconClasses = "mobile-hidden";
  }

  willUpdate(changed) {
    super.willUpdate(changed);
    if (changed.has("brand") && !this.hasAttribute("include-token")) {
      this.includeToken = this.brand !== "lovoo";
    }
  }
}

customElements.define("buy-credits-button", BuyCreditsButton);
